import React, { useState } from "react";
import { Pizza, Bike } from "lucide-react";
import PageHeader from "../../components/PageHeader";
import HistoricoProducao from "./Producao";
import HistoricoEntrega from "./Entrega";

const Historicos: React.FC = () => {
  const [activeTab, setActiveTab] = useState<"producoes" | "entregas">(
    "producoes"
  );

  return (
    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <PageHeader
        title="Históricos"
        description="Visualize o histórico completo de produções e entregas"
      />

      <div className="mt-6">
        <nav className="flex w-fit overflow-hidden rounded-lg border border-neutral-200 shadow-sm">
          <button
            onClick={() => setActiveTab("producoes")}
            className={`flex items-center gap-2 px-6 py-3 text-sm font-medium transition-colors ${
              activeTab === "producoes"
                ? "bg-primary text-white"
                : "bg-neutral-50 text-neutral-600 hover:bg-neutral-100 hover:text-neutral-800"
            }`}
          >
            <Pizza size={16} />
            Histórico de Produção
          </button>
          <button
            onClick={() => setActiveTab("entregas")}
            className={`flex items-center gap-2 px-6 py-3 text-sm font-medium transition-colors ${
              activeTab === "entregas"
                ? "bg-primary text-white"
                : "bg-neutral-50 text-neutral-600 hover:bg-neutral-100 hover:text-neutral-800"
            }`}
          >
            <Bike size={16} />
            Histórico de Entregas
          </button>
        </nav>

        <div className="mt-6">
          {activeTab === "producoes" && <HistoricoProducao />}
          {activeTab === "entregas" && <HistoricoEntrega />}
        </div>
      </div>
    </div>
  );
};

export default Historicos;
